// import React, { useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import "./styles/TrainScroll.css";

// const TrainScroll = ({ origins, productsData }) => {
//     const navigate = useNavigate();
//     const handleNavigation = (path) => {
//         navigate(path);
//     };

//     useEffect(() => {
//         const handleScroll = () => {
//             const homePageElement = document.querySelector(".homePage");
//             const scrollContainer = document.querySelector(".scroll-container");
//             const barElement = document.querySelector(".bar");

//             if (homePageElement && scrollContainer && barElement) {
//                 const screenHeight = window.innerHeight;
//                 const scrollTop = homePageElement.scrollTop - (screenHeight / 4); // Vertical scroll position of the element
//                 const containerHeight = scrollContainer.offsetHeight;

//                 if (scrollTop > (screenHeight / 4) && scrollTop < (containerHeight - (screenHeight / 4))) {
//                     const movingElement = document.querySelector(".moving-object");
//                     if (movingElement) {
//                         movingElement.style.position = "absolute";
//                         movingElement.style.top = `${scrollTop - 15}px`;
//                         movingElement.style.zIndex = 100;
//                     }

//                     barElement.style.backgroundPosition = `0 ${scrollTop - (screenHeight / 4) - 150}px`;
//                 }
//             }

//             // Handle the visibility of bar-node elements
//             const barNodes = document.querySelectorAll(".bar-node");
//             const screenHeight = window.innerHeight;

//             barNodes.forEach((node) => {
//                 const rect = node.getBoundingClientRect();
//                 if (rect.top >= 0 && rect.bottom <= (screenHeight * 2 / 3)) {
//                     // The bar-node is fully within the viewport
//                     node.style.backgroundColor = "#a1b787";  // Change color when visible
//                     node.style.opacity = 1;
//                 } else if (rect.top < screenHeight && rect.bottom > 0) {
//                     // The bar-node is partially within the viewport
//                     node.style.backgroundColor = "#e9eee4";  // Change color when partially visible
//                     node.style.opacity = 0.5;
//                 } else {
//                     // The bar-node is outside the viewport
//                     node.style.backgroundColor = "#e9eee4";  // Reset color when out of view
//                     node.style.opacity = 0.4;
//                 }
//             });

//             // Handle the visibility of bar-node elements
//             const barNodes2 = document.querySelectorAll(".station-info *");
//             const screenHeight2 = window.innerHeight;

//             barNodes2.forEach((node) => {
//                 const rect = node.getBoundingClientRect();
//                 if (rect.top >= 0 && rect.bottom <= (screenHeight2 - 75)) {
//                     // The bar-node is fully within the viewport
//                     node.style.color = "#23370a";  // Change color when visible
//                     node.style.opacity = 1;
//                 } else if (rect.top < screenHeight2 && rect.bottom > 0) {
//                     // The bar-node is partially within the viewport
//                     node.style.color = "#a1b787";  // Change color when partially visible
//                     node.style.opacity = 0.2;
//                 } else {
//                     // The bar-node is outside the viewport
//                     node.style.color = "#e9eee4";  // Reset color when out of view
//                     node.style.opacity = 0;
//                 }
//             });
//         };

//         const homePageElement = document.querySelector(".homePage");
//         if (homePageElement) {
//             homePageElement.addEventListener("scroll", handleScroll);
//         }

//         return () => {
//             if (homePageElement) {
//                 homePageElement.removeEventListener("scroll", handleScroll);
//             }
//         };
//     }, []);

//     const keys = origins ? Object.keys(origins) : [];

//     return (
//         <div className="scroll-container">
//             <div className="moving-object"></div>
//             <div className="bar"></div>
//             {keys.map((origin, index) => (
//                 <section key={index} className="station-section">
//                     <div className="bar-node"></div>
//                     <div className="station-info">
//                         <h2>{origin}</h2>
//                         <ul>
//                             {productsData.length > 0 ? (
//                                 productsData.filter((product) => product.Origin === origin).map((item, index) => (
//                                     <li key={index} item={item} onClick={() => handleNavigation(`/Product/${item.Name}`)}>
//                                         {item.Name}
//                                     </li>
//                                 ))
//                             ) : (
//                                 <li>No items available for this category</li>
//                             )}
//                         </ul>
//                         <div style={{ width: "100%", display: "flex", flexWrap: "wrap", justifyContent: "start", gap: "10px" }}>
//                             {productsData.length > 0 ? (
//                                 productsData.filter((product) => product.Origin === origin).map((item, index) => (
//                                     <img src={item.Img} alt={item.Name} key={index} item={item} style={{ width: "10vw", height: "10vw", minWidth: "50px", minHeight: "50px" }} onClick={() => handleNavigation(`/Product/${item.Name}`)} />
//                                 ))
//                             ) : (
//                                 <li>No items available for this category</li>
//                             )}
//                         </div>
//                     </div>
//                 </section>
//             ))}
//         </div>
//     );
// };

// export default TrainScroll;
import React, { useEffect, useState } from "react";
import "./styles/TrainScroll.css";

const TrainScroll = ({ origins, onStationChange }) => {
    const [activeStation, setActiveStation] = useState(null);

    useEffect(() => {
        const handleScroll = () => {
            const scrollContainer = document.querySelector(".scroll-container");
            const barNodes = document.querySelectorAll(".bar-node");
            const movingObject = document.querySelector(".moving-object");

            if (!scrollContainer || !barNodes || !movingObject) return;

            const scrollLeft = scrollContainer.scrollLeft;
            const containerWidth = scrollContainer.offsetWidth;

            // Update moving-object position
            const movingObjectLeft = scrollLeft + containerWidth / 2 - movingObject.offsetWidth / 2;
            movingObject.style.left = `${movingObjectLeft}px`;

            // Update bar-node visibility
            let activeStationKey = null;
            barNodes.forEach((node, index) => {
                const rect = node.getBoundingClientRect();
                const containerRect = scrollContainer.getBoundingClientRect();
                const isVisible =
                    rect.left >= containerRect.left && rect.right <= containerRect.right;

                if (isVisible) {
                    node.style.backgroundColor = "#a1b787"; // Highlight visible node
                    const stationInfo = node.nextElementSibling;
                    if (stationInfo) {
                        stationInfo.classList.add("visible");
                    }
                    activeStationKey = Object.keys(origins)[index];
                } else {
                    node.style.backgroundColor = "#e9eee4"; // Reset non-visible node
                    const stationInfo = node.nextElementSibling;
                    if (stationInfo) {
                        stationInfo.classList.remove("visible");
                    }
                }
            });

            // Update active station
            if (activeStationKey !== activeStation) {
                setActiveStation(activeStationKey);
                if (onStationChange) onStationChange(activeStationKey);
            }
        };

        const scrollContainer = document.querySelector(".scroll-container");
        if (scrollContainer) {
            scrollContainer.addEventListener("scroll", handleScroll);
        }

        return () => {
            if (scrollContainer) {
                scrollContainer.removeEventListener("scroll", handleScroll);
            }
        };
    }, [activeStation, origins, onStationChange]);

    const keys = origins ? Object.keys(origins).filter(origin => origin !== undefined && origin !== null) : [];

    return (
        <div className="scroll-container">
            <div className="moving-object"></div>
            <div className="tracks">
                <div className="rails"></div>
            </div>
            <div className="stations-wrapper">
                {keys.map((origin, index) => (
                    origin ? ( // Ensure origin is defined
                        <section key={index} className="station-section">
                            <div className="bar-node"></div>
                            <div className="station-info">
                                <h1>{origin}</h1>
                            </div>
                        </section>
                    ) : null // Do not render if undefined
                ))}
            </div>
        </div>
    );
};

export default TrainScroll;


